import React from 'react';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as taskMonitorActions from 'actions/admin/taskMonitor';
import { BaseHOC, withBaseHOCProps } from '../common/BaseHOC';

const initialState = {
  loaded: false,
};

export const withTaskMonitor = (WrappedComponent) => {
  class WithTaskMonitor extends BaseHOC {
    state = { ...initialState };

    async componentDidMount() {
      const { getAllTaskMonitor } = this.props;
      
      if (!this.state.loaded && getAllTaskMonitor) {
        try {
          await getAllTaskMonitor();
          this.setState({ ...initialState, loaded: true });
        } catch (error) {
          console.error('Failed to load task monitor data:', error);
        }
      }
    }

    getTaskStatistics = async (timeframe = '24h') => {
      const { getTaskStatistics } = this.props;
      if (getTaskStatistics) {
        return await getTaskStatistics(timeframe);
      }
    };

    getFailedTasks = async () => {
      const { getFailedTasks } = this.props;
      if (getFailedTasks) {
        return await getFailedTasks();
      }
    };

    cleanupOldTasks = async (days = 30) => {
      const { cleanupOldTasks } = this.props;
      if (cleanupOldTasks) {
        return await cleanupOldTasks(days);
      }
    };

    refreshTaskMonitor = async () => {
      const { getAllTaskMonitor } = this.props;
      if (getAllTaskMonitor) {
        try {
          const data = await getAllTaskMonitor();
          this.setState({ loaded: true });
          return data;
        } catch (error) {
          console.error('Failed to refresh task monitor data:', error);
          throw error;
        }
      } else {
        throw new Error('getAllTaskMonitor action not available');
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          loaded={this.state.loaded}
          getTaskStatistics={this.getTaskStatistics}
          getFailedTasks={this.getFailedTasks}
          cleanupOldTasks={this.cleanupOldTasks}
          refreshTaskMonitor={this.refreshTaskMonitor}
        />
      );
    }
  }

  const mapStateToProps = ({ taskMonitor }) => {
    return { taskMonitor };
  };

  const TaskMonitorHOC = connect(
    mapStateToProps,
    taskMonitorActions,
  )(WithTaskMonitor);

  hoistNonReactStatics(TaskMonitorHOC, WrappedComponent);

  return compose(withBaseHOCProps)(TaskMonitorHOC);
};

export default withTaskMonitor;